import {
  PaymentFormField,
  PaymentStates,
  PaymentTypes,
  ResultAction,
  ResultActionTypes,
  ResultTypes,
} from '@cashier/cashier-model';
import { PaymentStateChecker } from '@cashier/cashier-shared';

const SHOW_STATUS = 'showStatus';

interface PaymentResultConfigurationInput {
  resultAction: ResultAction | null;
  completionBehaviour: 'keepInformation' | 'showStatus';
  paymentType: PaymentTypes | null;
  paymentState: PaymentStates | null;
  amount: string;
  currency: string;
  paymentMethodMessage: string | null;
  onButtonClick: () => void;
}

interface InformationResultConfiguration {
  type: ResultTypes.INFORMATION;
  configuration: {
    amount: string;
    currency: string;
    fields: PaymentFormField[];
    paymentMethodMessage: string | null;
    onButtonClick: () => void;
  };
}

interface StatusResultConfiguration {
  type: ResultTypes.STATUS;
  configuration: {
    amount: string;
    currency: string;
    paymentMethodMessage: string | null;
    onButtonClick: () => void;
  };
}

export type PaymentResultConfiguration =
  | InformationResultConfiguration
  | StatusResultConfiguration;

export const PaymentResultConfigurator = {
  configure: ({
    resultAction,
    completionBehaviour,
    paymentType,
    paymentState,
    amount,
    currency,
    paymentMethodMessage,
    onButtonClick,
  }: PaymentResultConfigurationInput): PaymentResultConfiguration => {
    const getResultType = (): ResultTypes => {
      if (ResultActionTypes.DISPLAY !== resultAction?.type) {
        return ResultTypes.STATUS;
      }

      const hasResult =
        !!paymentState &&
        PaymentStateChecker.hasResult(paymentType, paymentState);

      return SHOW_STATUS === completionBehaviour && hasResult
        ? ResultTypes.STATUS
        : ResultTypes.INFORMATION;
    };

    if (ResultTypes.INFORMATION === getResultType()) {
      return {
        type: ResultTypes.INFORMATION,
        configuration: {
          amount,
          currency,
          fields: resultAction?.fields || [],
          paymentMethodMessage,
          onButtonClick,
        },
      };
    }

    return {
      type: ResultTypes.STATUS,
      configuration: {
        amount,
        currency,
        paymentMethodMessage,
        onButtonClick,
      },
    };
  },
};
